import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "../../../ModelAlert.css";

export const ModalSwitchBusiness = ({
  isOpen,
  onClose,
  currentName,
  nextName,
  onConfirm,
  confirmDisabled = false,
  confirmText = "Sí, cambiar",
}) => {
  return (
    <Modal isOpen={isOpen} id="modal_alert">
      <ModalHeader className="justify-content-end">
        <button
          className="close bg-transparent border-0"
          onClick={onClose}
        >
          <span>&times;</span>
        </button>
      </ModalHeader>

      <ModalBody className="modal-body">
        <p className="modal_title">
          Cambiar unidad de negocio
          <br />
          <br />
        </p>
        <p className="modal_text_info">
          Usted está en la unidad de negocio <b>{currentName}</b>, ¿desea
          cambiar a <b>{nextName}</b>?
        </p>
        <div className="row mt-4" style={{ gap: 10 }}>
          <button
            className="btn btn-primary col"
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmText}
          </button>

          <button
            className="btn btn-light col"
            onClick={onClose}
            disabled={confirmDisabled}
          >
            Cancelar
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};
